import React from 'react'

import { ProductBox, useProductBox } from '@fourthwall/module-product'

import type { useOfferMigrateProductOptionsQuery } from '../../../../../../hooks/useOfferMigrateProductOptionsQuery/useOfferMigrateProductOptionsQuery'

type ProductOptions = NonNullable<
  ReturnType<typeof useOfferMigrateProductOptionsQuery>['offerMigrateProductOptionsQuery']['data']
>['migrationOptions']

type AnotherProductThumbnailProps = {
  product: ProductOptions[number]
  checked: boolean
  onChange?: (product: ProductOptions[number]) => void
}

export const AnotherProductThumbnail = ({
  product,
  checked,
  onChange,
}: AnotherProductThumbnailProps) => {
  const { activeProduct, activeColorVariant, setActiveProductionMethod } = useProductBox({
    product,
  })

  return (
    <ProductBox.Radio
      key={product.id}
      label={product.name}
      name={product.name}
      value={product.id}
      checked={checked}
      onChange={() => {
        onChange?.(product)
      }}
    >
      <ProductBox
        href="#"
        interactive={false}
        product={product}
        activeProduct={activeProduct}
        activeColorVariant={activeColorVariant}
        setActiveProductionMethod={setActiveProductionMethod}
      />
    </ProductBox.Radio>
  )
}
